import React, { useState, useEffect } from "react";
import Spacer from "../../../Components/Spacer";
import Tabs from "../../../Components/Tabs";
import SeedConfigurationSetup from "./components/SeedConfigurationSettings";
import ReviewData from "./components/ReviewData";
import GoalData from "./components/GoalData";
import EmployeeData from "./components/EmployeeData";
import SeededCompanyLogs from "./components/SeededCompanyLogs";
import css from "./styles.styl";
import { useParams, useNavigation } from "../../../Hooks/useNavigation";

const VIEWS = {
	"seed-configuration-set-up": "Seed Configuration Set Up",
	"employee-data": "Employee Data",
	"review-data": "Review Data",
	"goal-data": "Goal Data",
	"seeded-company-logs": "Seeded Company Logs",
};

/**
 * Main parent component for the seeder page that handles navigation between different seeding views
 * @returns {JSX.Element} The seeder parent page with tab navigation and view rendering
 */
const SeedParentPage = () => {
	const { view, configId } = useParams();
	const navigation = useNavigation();

	useEffect(() => {
		if (!view) {
			if (configId) {
				navigation.navigate(`/seed-company/seed-configuration-set-up/${configId}`);
			} else {
				navigation.navigate("/seed-company/seed-configuration-set-up");
			}
		}
	}, [view, configId, navigation]);

	/**
	 * Handle tab change navigation between different seeding views
	 * @param {string} tab - The name of the tab to navigate to
	 */
	const handleTabChange = (tab) => {
		const baseConfigPath = configId ? `/${configId}` : "";
		switch (tab) {
			case "Seed Configuration Set Up":
				navigation.navigate(`/seed-company/seed-configuration-set-up${baseConfigPath}`);
				break;
			case "Employee Data":
				navigation.navigate(`/seed-company/employee-data${baseConfigPath}`);
				break;
			case "Review Data":
				navigation.navigate(`/seed-company/review-data${baseConfigPath}`);
				break;
			case "Goal Data":
				navigation.navigate(`/seed-company/goal-data${baseConfigPath}`);
				break;
			case "Seeded Company Logs":
				navigation.navigate(`/seed-company/seeded-company-logs${baseConfigPath}`);
				break;
			default:
				navigation.navigate(`/seed-company/seed-configuration-set-up${baseConfigPath}`);
				break;
		}
	};

	const currentView = view || "seed-configuration-set-up";

	return (
		<div className={css.container}>
			<Tabs currentTab={VIEWS[currentView]} tabs={Object.values(VIEWS)} onChange={handleTabChange} />

			{currentView === "seed-configuration-set-up" ? (
				<SeedConfigurationSetup view={view} configId={configId} />
			) : null}
			{currentView === "employee-data" ? (
				<div>
					<Spacer size={6} />
					<EmployeeData />
				</div>
			) : null}
			{currentView === "review-data" ? (
				<div>
					<Spacer size={6} />
					<ReviewData />
				</div>
			) : null}
			{currentView === "goal-data" ? (
				<div>
					<Spacer size={6} />
					<GoalData />
				</div>
			) : null}
			{currentView === "seeded-company-logs" ? (
				<div>
					<Spacer size={6} />
					<SeededCompanyLogs />
				</div>
			) : null}
		</div>
	);
};

export default SeedParentPage;
